import { CookieKeys } from "@outschool/data-schemas";
import {
  ANALYTICS_EVENTS_TOPIC,
  AnalyticsPluginRestProxyTrackArgs,
  RestProxyBrowserClient,
} from "@outschool/event-tracking-client";
import { useFeatureFlag } from "@outschool/ui-components-shared";
import Cookies from "js-cookie";
import React from "react";

import pkg from "../../lib/pkg";
import useAnalytics from "../useAnalytics";

let restProxyClient: RestProxyBrowserClient | undefined;

export default function useAnalyticsEventLogger() {
  const analytics = useAnalytics();
  const shouldLog = useFeatureFlag("enable-fe-signup-logging");
  // The endpoint is unset when the host app skips analytics init (e.g. local
  // dev without a Segment key); signup must still work, just without logging.
  if (!restProxyClient && pkg.eventTrackingEndpoint) {
    restProxyClient = new RestProxyBrowserClient({
      endpoint: pkg.eventTrackingEndpoint,
    });
  }

  const loggedInUserExperimentUid = Cookies.get(
    CookieKeys.LoggedInUserExperimentUid,
  );
  const loggedOutUserExperimentUid = Cookies.get(
    CookieKeys.LoggedOutUserExperimentUid,
  );

  return React.useCallback(
    async (eventData: any) => {
      if (!shouldLog || !restProxyClient) {
        return;
      }
      logEvent({
        restProxyClient,
        anonymous_id: await analytics.anonymousId(),
        loggedInUserExperimentUid,
        loggedOutUserExperimentUid,
        eventData,
      });
    },
    [
      loggedInUserExperimentUid,
      loggedOutUserExperimentUid,
      analytics,
      shouldLog,
    ],
  );
}

function getEventTrackArgs(payload: any): AnalyticsPluginRestProxyTrackArgs {
  return {
    event: payload,
    topic: ANALYTICS_EVENTS_TOPIC,
  };
}

function logEvent({
  restProxyClient,
  anonymous_id,
  loggedInUserExperimentUid,
  loggedOutUserExperimentUid,
  eventData,
}: {
  restProxyClient: RestProxyBrowserClient;
  anonymous_id: string | undefined;
  loggedInUserExperimentUid?: string;
  loggedOutUserExperimentUid?: string;
  eventData: any;
}) {
  try {
    restProxyClient.sendEvent(
      getEventTrackArgs({
        original_timestamp: new Date().toISOString(),
        event_name: "signup",
        event_data: JSON.stringify(eventData),
        user_uid: null,
        anonymous_id,
        logged_in_user_experiment_uid: loggedInUserExperimentUid,
        logged_out_user_experiment_uid: loggedOutUserExperimentUid,
        user_agent: navigator.userAgent.slice(0, 200),
      }),
    );
  } catch {
    console.error("Was unable to log");
  }
}
